import { File, Folder, davParsePermissions, getDavNameSpaces, getDavProperties } from '@nextcloud/files';
import { generateRemoteUrl, generateUrl } from '@nextcloud/router';
import { getCurrentUser } from '@nextcloud/auth';
import client, { rootPath } from './client';
const data = `<?xml version="1.0"?>
<d:propfind ${getDavNameSpaces()}>
	<d:prop>
		<nc:trashbin-filename />
		<nc:trashbin-deletion-time />
		<nc:trashbin-original-location />
		<nc:trashbin-title />
		${getDavProperties()}
	</d:prop>
</d:propfind>`;
const resultToNode = function (node) {
    const permissions = davParsePermissions(node.props?.permissions);
    const owner = getCurrentUser()?.uid;
    const previewUrl = generateUrl('/apps/files_trashbin/preview?fileId={fileid}&x=32&y=32', node.props);
    const nodeData = {
        id: node.props?.fileid || 0,
        source: generateRemoteUrl('dav' + rootPath + node.filename),
        // do not show the mtime column
        // mtime: new Date(node.lastmod),
        mime: node.mime,
        size: node.props?.size || 0,
        permissions,
        owner,
        root: rootPath,
        attributes: {
            ...node,
            ...node.props,
            // Override displayed name on the list
            displayName: node.props?.['trashbin-filename'],
            previewUrl,
        },
    };
    delete nodeData.attributes.props;
    return node.type === 'file'
        ? new File(nodeData)
        : new Folder(nodeData);
};
export const getContents = async (path = '/') => {
    // TODO: use only one request when webdav-client supports it
    // @see https://github.com/perry-mitchell/webdav-client/pull/334
    const rootResponse = await client.stat(path, {
        details: true,
        data,
    });
    const contentsResponse = await client.getDirectoryContents(path, {
        details: true,
        data,
    });
    return {
        folder: resultToNode(rootResponse.data),
        contents: contentsResponse.data.map(resultToNode),
    };
};
